var _polygon, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadSigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,5 95,30 95,70 50,95 5,70 5,30",
    fill: "red",
    stroke: "black",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 55,
    fontSize: 20,
    fontWeight: "bold",
    fill: "white"
  }, "STOP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSigns);
export default __webpack_public_path__ + "static/media/road-signs.15e1ee53845bdbd9808244d409864b2e.svg";
export { ForwardRef as ReactComponent };